import { ButtonBase } from '@material-ui/core';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderCard } from '../../../../components/Header/CardHeader';
import { IDocumentType } from '../../../../entity/einvoice/Document/IDocument';
import { CButton } from '../../../../Elements/Buttons/Button';
import { faXmark } from '../../../../assets/fontAwesome/solid/faXmark';
import { changeDocumentTypeStatus } from '../../../../repository/DocumentRepository';
import { faCheck } from '../../../../assets/fontAwesome/light/faCheck';

interface IProps {
  documentTypes: IDocumentType[];
  title: string;
  onDocumentTypeClick: (documentTypeUuid: string) => void;
  reloadDocumentTypes: () => void;
}

export const DocumentTypesList: FC<IProps> = ({
  documentTypes,
  title,
  onDocumentTypeClick,
  reloadDocumentTypes,
}) => {
  const { t } = useTranslation();

  const incomeDocumentTypes = documentTypes.filter(type => type.income === true);
  const outcomeDocumentTypes = documentTypes.filter(type => type.income === false);

  const handleDocumentTypeStatusChange = (uuid: string, isActive: boolean) => {
    changeDocumentTypeStatus(uuid, !isActive)
      .then(() => reloadDocumentTypes())
      .catch(() => {});
  };

  return (
    <div className="mr-4">
      <HeaderCard title={title} />
      <div className="custom-list-content document-type">
        <HeaderCard title={t('Income')} />
        {incomeDocumentTypes.map((type, i) => (
          <Fragment key={type.uuid!}>
            <div className="flex align-center">
              <ButtonBase
                onClick={() => onDocumentTypeClick(type.uuid!)}
                className="p-2 button-base">
                <div>
                  <DescriptionOutlinedIcon />{' '}
                  <span className="ml-1">
                    {type.name} ({t('Income')})
                  </span>
                </div>
              </ButtonBase>
              <CButton
                size="s"
                className={type.active ? 'danger-btn' : 'active-btn'}
                icon={type.active ? faXmark : faCheck}
                onClick={() => handleDocumentTypeStatusChange(type.uuid!, type.active!)}
              />
            </div>
            <hr hidden={i === documentTypes.length - 1} className="my-1" />
          </Fragment>
        ))}
      </div>
      <div className="custom-list-content document-type">
        <HeaderCard title={t('Outcome')} />
        {outcomeDocumentTypes.map((type, i) => (
          <Fragment key={type.uuid!}>
            <div className="flex align-center">
              <ButtonBase
                onClick={() => onDocumentTypeClick(type.uuid!)}
                className="p-2 button-base">
                <div>
                  <DescriptionOutlinedIcon />{' '}
                  <span className="ml-1">
                    {type.name} ({t('Outcome')})
                  </span>
                </div>
              </ButtonBase>
              <CButton
                size="s"
                className={type.active ? 'danger-btn' : 'active-btn'}
                icon={type.active ? faXmark : faCheck}
                onClick={() => handleDocumentTypeStatusChange(type.uuid!, type.active!)}
              />
            </div>
            <hr hidden={i === outcomeDocumentTypes.length - 1} className="my-1" />
          </Fragment>
        ))}
      </div>
    </div>
  );
};
